import api from './api';

export const addonPackageService = {
  async getAddonPackages() {
    const response = await api.get('/addon-packages');
    return response.data;
  },

  async getAddonPackage(id) {
    const response = await api.get(`/addon-packages/${id}`);
    return response.data.data;
  },

  async createAddonPackage(data) {
    const response = await api.post('/addon-packages', data);
    return response.data.data;
  },

  async updateAddonPackage(id, data) {
    const response = await api.put(`/addon-packages/${id}`, data);
    return response.data.data;
  },

  async deleteAddonPackage(id) {
    const response = await api.delete(`/addon-packages/${id}`);
    return response.data.data;
  },
};
